// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3wy06","tagline":"header_tagline__1Q6WD","nswGovLogo":"header_nswGovLogo__3KTxp"};